<style lang="scss" scoped>
.cart-float-container {
  position: fixed;
  width: 96px;
  height: 96px;
  right: 24px;
  bottom: 168px;
  background-color: #fff;
  box-shadow: 0px 2px 18px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  .cart-icon {
    width: 37px;
    height: 36px;
  }

}
</style>

<template>
  <div class="cart-float-container" @click="goToCart">
    <img class="cart-icon" src="https://oss.turingsenseai.com/1626772772335007776.png" />
  </div>
  
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {
    goToCart() {
      this.$router.push({
        path: '/purchase-test/cart-list'
      })
    }
  }
}
</script>